import Link from '../TravelokaLink'
import classnames from 'clsx'
import { useState } from 'react'
import { Dropdown, DropdownTrigger, DropdownContent, DropdownMenu, DropdownItem } from 'bloomer'
import { useLocations } from 'lib/context/Location'
import Image from 'components/Image/SimpleImage'

import styles from './style.module.scss'
import { has, isEmpty } from 'lodash'
import ensureBasePath from '../../lib/ensureBasePath'
import Markdown from 'react-markdown'
import { ensureGetData } from 'lib/helpers'
import clsx from 'clsx'

export const Footer = ({ pageProps }) => {
  const locations = useLocations()

  const [currentLocation, setCurrentLocation] = useState(0)
  const [active, setActive] = useState(false)

  const mapsSearchLink = address => `//www.google.com/maps/search/${encodeURIComponent(address)}`

  const getLink = location => {
    if (has(location, 'link') && !isEmpty(location.link)) return location.link
    else return mapsSearchLink(location.address)
  }

  const hasLegalNotes = has(pageProps, 'legalNotes') && !isEmpty(pageProps.legalNotes)
  return (
    <footer className={styles.footer}>
      <div className="container">
        {hasLegalNotes && (
          <div className="columns">
            <Markdown
              className={clsx('section-copy', styles.legal_notes)}
              allowDangerousHtml
              source={pageProps.legalNotes}
            />
          </div>
        )}
        <div className="columns">
          <div className="column is-2-tablet">
            <a href="https://www.traveloka.com/en-id/" rel="noreferrer" target="_blank">
              <Image
                width={120}
                height={35}
                src={ensureBasePath('/images/icons/logo-footer.svg?inline')}
                alt="Traveloka"
                className={styles.logo}
              />
            </a>
          </div>
          <div className="column is-10-tablet">
            <div className="content">
              <div className="columns">
                <div className={classnames('column is-one-fifths', styles.location_column)}>
                  <div className={classnames('card', styles.card)}>
                    <div className={classnames(styles.card_content)}>
                      <div
                        className={classnames('footer-location-dropdown', styles.location_title)}>
                        <Dropdown isActive={active}>
                          <DropdownTrigger onClick={() => setActive(!active)}>
                            <span> {locations[currentLocation].city} </span>
                          </DropdownTrigger>
                          <DropdownMenu>
                            <DropdownContent>
                              {locations.map((item, index) => (
                                <DropdownItem
                                  key={item.id}
                                  onClick={() => {
                                    setCurrentLocation(index)
                                    setActive(false)
                                  }}>
                                  {item.city}
                                </DropdownItem>
                              ))}
                            </DropdownContent>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                      <div className={styles.location}>
                        <p className={styles.location_address}>
                          {locations[currentLocation].address}
                        </p>
                        <a
                          className={styles.location_link}
                          href={getLink(locations[currentLocation])}
                          target="_blank"
                          rel="noreferrer">
                          View Map
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classnames('column is-one-fifths', styles.nav_column)}>
                  <h5 className={styles.title}>
                    <Link href="/">
                      <a>About Traveloka </a>
                    </Link>
                  </h5>
                  <ul className={styles.list}>
                    <li>
                      <Link href="/#who-we-are">
                        <a>Who We Are</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/#core-value-traveloka">
                        <a>Traveloka&apos;s Core Value</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/#facts">
                        <a>Facts</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/#discover-our-team">
                        <a>Discover Our Team</a>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className={classnames('column is-one-fifths', styles.nav_column)}>
                  <h5 className={styles.title}>
                    <Link href="/traveloka-life">
                      <a>Life at Traveloka</a>
                    </Link>
                  </h5>
                  <ul className={styles.list}>
                    <li>
                      <Link href="/traveloka-life#perks-of-working-at-traveloka">
                        <a>Perks of Working at Traveloka</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/traveloka-life#inside-traveloka">
                        <a>Inside Traveloka</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/traveloka-life#employee-stories">
                        <a>Employee Stories</a>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className={classnames('column is-one-fifths', styles.nav_column)}>
                  <h5 className={styles.title}>
                    <Link href="/student-graduate">
                      <a>Student &amp; Graduates</a>
                    </Link>
                  </h5>
                  <ul className={styles.list}>
                    <li>
                      <Link href="/student-graduate/internship-program">
                        <a>Internship</a>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className={classnames('column is-one-fifths', styles.nav_column)}>
                  <h5 className={styles.title}>
                    <Link href="/vacancies">
                      <a>Vacancies</a>
                    </Link>
                  </h5>
                </div>
              </div>
            </div>
            <div className={classnames('section-subtitle', styles.copy_holder)}>
              <div className="columns">
                <div className="column is-one-fifths">
                  {/* <a href="https://www.traveloka.com/en/" target="_blank">
                    Traveloka.com
                  </a> */}
                </div>
                <div className="column is-three-fifths">
                  {/* <a href="https://press.traveloka.com/" target="_blank">
                    Traveloka Press Room
                  </a> */}
                </div>
                <div className="column is-one-fifths">
                  <p>
                    Copyright &copy; {new Date().getFullYear()}
                    &nbsp;Traveloka
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
